module.exports = __webpack_public_path__ + "assets/20cb3b666ff7fb780da086c7111a9cec.mp4";